define('models/adServer',["T1", "T1Model", "Backbone"], function (T1, T1Model, Backbone) {
  T1.Models.AdServer = T1Model.extend({
    url: "ad_servers/",
    fixture: "-adServer"
  });
  return T1.Models.AdServer;
});
